import Seo from '@/components/base/Seo';
import Hero from './components/Hero';
import HotSerials from './components/HotSerials';
import Categories from './components/Categories';
import Latest from './components/Latest';
import Picks from './components/Picks';
import About from './components/About';
import Faq from './components/Faq';
import Cta from './components/Cta';

const jsonLd = [
  {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '麻瓜漫画网',
    url: 'https://uncutm.github.io/',
    inLanguage: 'zh-CN',
  },
  {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '麻瓜漫画网',
    url: 'https://uncutm.github.io/',
    logo: 'https://uncutm.github.io/logo.png',
    contactPoint: {
      '@type': 'ContactPoint',
      email: 'hello@mugua-manhua.com',
      contactType: 'customer service',
    },
  },
];

export default function Home() {
  return (
    <>
      <Seo
        title="麻瓜漫画网 - 原版漫画无删减完整版高清在线看"
        description="麻瓜漫画网提供原版漫画在线阅读，收录高清完整版、未删减原版与导演剪辑版漫画资源，覆盖奇幻、都市、科幻、武侠等热门分类，每日更新最新章节，随时随地畅快追更。"
        keywords="麻瓜漫画网,原版漫画,完整版漫画,未删减漫画,导演剪辑版,漫画在线看"
        canonical="https://uncutm.github.io/"
        jsonLd={jsonLd}
      />
      <Hero />
      <HotSerials />
      <Categories />
      <Latest />
      <Picks />
      <About />
      <Faq />
      <Cta />
    </>
  );
}